// PrimeNG's default is 3 seconds, too short to read a sentence.
export const TOAST_LIFE_MS = 5000;
